module.exports = __webpack_public_path__ + "static/media/blurpassport.7681021f.png";